/* unplugin-vue-components disabled */import { render } from "./PollQuiz.vue?vue&type=template&id=356af70a&scoped=true&ts=true"
import script from "./PollQuiz.vue?vue&type=script&lang=ts"
export * from "./PollQuiz.vue?vue&type=script&lang=ts"

import "./PollQuiz.vue?vue&type=style&index=0&id=356af70a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356af70a"]])

export default __exports__